import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UserApi } from 'services/user';
import { BloxButton } from 'styled_components/Common/BloxButton';
import { SuccessMessage, ErrorMessage } from 'utils/CommonConstants';
import RadioButton from 'sub_components/Common/Radio';
import ScrollView from 'sub_components/Common/BloxScrollViewNew';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const badgeImage = `${CDN_URL}profile/icon-badge.svg`;

const OPTIONS = [
	{ name: 'Lost', value: 'Lost' },
	{ name: 'Stolen', value: 'Stolen' },
	{ name: 'Revoked', value: 'Revoked' },
];

class BadgeModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			badges: null,
			reasons: [],
		};
	}

	updateBadge = (badge, reason) => {
		const {
			organizationId,
			setModalContent,
			getBadgeDetails,
			auth_status: { user } = {},
		} = this.props;
		setModalContent('CLOSE');
		const cancelButton = document.getElementById(`${badge?.badgeId}-manage-badge`);

		if (cancelButton) {
			cancelButton.classList.add('active');
		}
		//const { selectedLocation } = this.props;

		const params = {
			rosterUserId: badge?.rosteruserId,
			disabled: !badge?.disabled,
			guid: badge?.guid,
			objectId: badge?.systemObjectId,
			datacenter: badge?.datacenter,
			reason,
			organizationId,
			userId: user?.id,
		};
		const button = (
			<BloxButton
				className='buttons41'
				id='okay'
				text='OKAY'
				module='support'
				enabled={true}
				onClick={() => {}}
				cypressId='okay'
			/>
		);

		UserApi.updateBadgeDetails(params)
			.then(response => {
				const validResponse = response.status === 200 && response.data?.updated;
				if (validResponse) {
					getBadgeDetails(badge?.rosteruserId);
					setModalContent('TIMEOUT_CLOSE', SuccessMessage, button);
				} else {
					setModalContent('TIMEOUT_CLOSE', ErrorMessage, button);
				}
			})
			.catch(() => {
				setModalContent('TIMEOUT_CLOSE', ErrorMessage, button);
			});
	};
	onClick = (reason, index) => {
		const { reasons } = this.state;
		if (reasons.some(e => e.reasonIndex === index)) {
			const componentIndex = reasons.findIndex(x => x.reasonIndex === index);
			this.setState(
				// eslint-disable-next-line
				state => (state.reasons[componentIndex].reason = reason),
			);
		} else {
			const newUpdates = [...reasons];
			newUpdates.push({
				reasonIndex: index,
				reason,
			});
			this.setState({ reasons: newUpdates });
		}
	};

	getDisabledMessage = badge => {
		let message = '';
		if (badge?.stolen) {
			message =
				'Looks like this badge has been reported as stolen, Please contact the Datacenter Manager to reactivate.';
		} else if (badge?.lost) {
			message =
				'Looks like this badge has been reported as lost, Please contact the Datacenter Manager to reactivate.';
		} else if (badge?.revoked) {
			message =
				'Looks like this badge has been revoked, Please contact the Datacenter Manager to reactivate.';
		} else if (!badge?.active) {
			message =
				'Looks like this badge has been deactivated, Please contact the Datacenter Manager to reactivate.';
		}
		return message;
	};

	confirmBadgeUpdate = (badge, reason) => {
		const { setModalContent } = this.props;

		const headerText =
			'Caution: To reactivate a badge you must wire 1 bitcoin to our development fund!';
		const button = (
			<BloxButton
				className='buttons41'
				id='confirm-cancel'
				text='CONTINUE'
				module='support'
				enabled={true}
				onClick={() => this.updateBadge(badge, reason)}
				cypressId='confirm-cancel'
			/>
		);
		setModalContent(false, headerText, button);
	};

	renderBadges = badges => {
		const { reasons } = this.state;
		const { hasEditRosterUserAccess } = this.props;

		if (!badges || badges.length === 0) {
			return <div className='body10'>No Badge Linked</div>;
		} else {
			return this.mapBadges(badges, reasons, hasEditRosterUserAccess);
		}
	};

	mapBadges = (badges, reasons, hasEditRosterUserAccess) => {
		return badges.map((badge, index) => {
			const expiration = badge?.expirationDt;
			const formattedExpiration = expiration && expiration.split(' ');
			const issued = badge?.issuedDt;
			const formattedIssued = issued && issued.split(' ');
			const componentIndex = reasons.findIndex(x => x.reasonIndex === index);
			const disabled = badge?.active ? false : true;
			return (
				<div className={disabled ? 'badge-detail-wrapper disabled' : 'badge-detail-wrapper'}>
					<div className='badge-access'>
						<img src={badgeImage} />
						<div className='body10'>{`# ${badge?.badgeId}`}</div>
					</div>
					<div className='body-detail-wrapper'>
						<div className='main-details'>
							<div className='body-detail'>
								<div className='label labels21'>Active</div>
								<div className='value body10'>{badge?.active ? 'True' : 'False'}</div>
							</div>
							<div className='body-detail'>
								<div className='label labels21'>Issued</div>
								<div className='value body10'>{formattedIssued?.[0]}</div>
							</div>
							<div className='body-detail'>
								<div className='label labels21'>Disabled</div>
								<div className='value body10'>{badge.disabled ? 'True' : 'False'}</div>
							</div>
							<div className='body-detail'>
								<div className='label labels21'>Expiration</div>
								<div className='value body10'>{formattedExpiration?.[0]}</div>
							</div>
							<div className='body-detail'>
								<div className='label labels21'>Issuing Location</div>
								<div className='value body10'>{badge?.datacenter}</div>
							</div>
						</div>
						<RadioButton
							callback={this.onClick}
							name={`reason-${badge?.badgeId}`}
							value={reasons[componentIndex]?.reason ? reasons[componentIndex]?.reason : ''}
							hidden={false}
							toggle={true}
							options={OPTIONS}
							index={index}
						/>
					</div>
					<div className='button-wrapper'>
						{hasEditRosterUserAccess && (
							<BloxButton
								className='buttons41'
								module='account'
								text={badge?.disabled ? 'ENABLE' : 'DISABLE'}
								enabled={reasons[componentIndex]?.reason ? true : false}
								onClick={() => {
									this.confirmBadgeUpdate(badge, reasons[componentIndex]?.reason);
								}}
								id={`${badge?.badgeId}-manage-badge`}
								cypressId='manage-badge'
							/>
						)}
						{!hasEditRosterUserAccess && (
							<div className='body10'>You do not have permission to edit badges.</div>
						)}
					</div>
					{disabled && (
						<div className='disabled-message body10'>{this.getDisabledMessage(badge)}</div>
					)}
				</div>
			);
		});
	};

	render() {
		const { badges } = this.props;
		return (
			<div className='badge-modal-wrapper'>
				<div className='badge-modal'>
					<ScrollView>
						<div className='badges-wrapper'>{this.renderBadges(badges)}</div>
					</ScrollView>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		site: state.site_tracking,
		auth_status: state.auth_status,
	};
}

export default connect(mapStateToProps)(BadgeModal);
